export const WEBSITE_DESIGN_TOOL_APP_NAME = 'servicecenter/websitedesigntool';
